import React, { useState } from 'react'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import { validateEmail, prepPdfForEmail } from '../../_global/js/Utils.js';

const EmailPdf = () => {
  
  const { showEmailModal, setShowEmailModal, pdfLink } = useStore(state =>({
    showEmailModal: state.showEmailModal,
    setShowEmailModal: state.setShowEmailModal,
    pdfLink: state.pdfLink,
  }), shallow);
  
  const [email, setEmail] = useState('');
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showThankyou, setShowThankyou] = useState(false);

  

  const sendEmailData = (e) => {
    e.preventDefault();
    let address = validateEmail(email);
    if(!address) {
      setInvalidEmail(true);
    }else{
      setInvalidEmail(false);
      prepPdfForEmail(email, pdfLink); 
      setShowForm(false);
      setShowThankyou(true);
    }
  }

  const closeModal = () => {
    setShowEmailModal(false);
    setShowForm(true);
    setShowThankyou(false);
    setEmail('');
  }

  const handleChange = (e) => {
    setEmail(e.target.value);
  }

  const showingModal = showEmailModal ? true : false;
  const showValidEmailError = invalidEmail ? true : false;

  return (
    <div className={`email_modal_container ${ showingModal ? '':'hide'}`}>    
      <form className={`email_modal_box email_modal_input ${showForm? '':'hide'}`}>
          <div className="email_modal_heading">Please enter your email:</div>
          <label htmlFor="pdfEmail">
              <input type="email" value={email} required placeholder="Email" name="pdfEmail" onChange={handleChange} id="pdfEmail"></input>
          </label>
          <input className="email_modal_submit" type="button" value="Submit" onClick={sendEmailData} />
          <div className={`email_modal_blank-email-error ${showValidEmailError ? '':'hide'}`}>Please enter a valid email address.</div>
          <button className="email_modal_close" onClick={closeModal}>X</button>
      </form>
      <div className={`email_modal_box email_modal_thankyou ${showThankyou ? '': 'hide'}`}>
          <div className="email_modal_thankyou-message">This summary has been emailed to you.</div>
          <button className="email_modal_close" onClick={closeModal}>X</button>
      </div>
  </div>
  )
}

EmailPdf.propTypes = {}

export default EmailPdf